import { lazy } from 'react';

import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import MainLayout from 'layout/MainLayout';


const Home = Loadable(lazy(() => import('pages/prediction-pages/home/Home')));
const NotFoundPage = Loadable(
    lazy(() => import("pages/home/not-found-page/NotFoundPage"))
  );
  const EntitySelectionPage = Loadable(
    lazy(() => import("pages/prediction-pages/crops/insects/insects-crops/EntitySelectionPage"))
  );
  const Chart = Loadable(lazy(() => import("../pages/Chart/ChartDisplay")));
  const PestThresholdPage = Loadable(lazy(() => import("pages/ddps/pest-threshold/PestThresholdPage")));
 
// ==============================|| DEGREE DAY PREDICTION ROUTING ||============================== //

const DegreeDayPredictionRoutes = {
    path: '/ddps',
  element: <MainLayout app = {'ddps'}/>,
    children: [
        {
            path: '/ddps',
            element: <Home />
        },
          {
            path: "/ddps/insects/select-entities-and-weather-station",
            element: <EntitySelectionPage/>,
          },
     
          {
            path: "*",
            element: <NotFoundPage link={"/degree-day-prediction"}/>,
          },
          {
            path: "/ddps/insects/degree-day-chart/:cropName/:cropId/:pestName/:pestId/station/:stationId",
            element: <Chart />,
          },
          {
            path: "/ddps/configure-pest-threshold/:cropName/:cropId/:pestName/:pestId",
            element: <PestThresholdPage />,
          },
    ]
};

export default DegreeDayPredictionRoutes;
//degree-day-chart